// 路由示例
import type { RouteRecordRaw } from "vue-router";
import { RouterName } from "@/enums/RouterEnum";
import { t } from "@/plugins/i18n";

const clientRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "layout",
    redirect: "/welcome",
    component: () => import("@/layout/Content/ClientContent.vue"),
    children: [
      {
        path: "/welcome",
        name: RouterName.WELCOME,
        component: () => import("@/views/welcome/index.vue"),
        meta: {
          title: t("routes.welcome"),
        },
      },
      {
        path: "/setting",
        name: RouterName.SETTING,
        component: () => import("@/views/setting/index.vue"),
        meta: {
          title: t("sys.menu.setting"),
        },
      },
      {
        path: "/about",
        name: RouterName.ABOUT,
        component: () => import("@/views/about/index.vue"),
        meta: {
          title: t("sys.menu.about"),
        },
      },
      {
        path: "myMessage",
        name: "myMessage",
        component: () => import("@/views/userCenter/myMessage/index.vue"),
        meta: {
          title: "我的消息",
        },
      },
      {
        path: "data-seller",
        name: "dataSeller",
        meta: {
          title: "数据卖家",
        },
        children: [
          {
            path: "my-data",
            name: RouterName.MY_DATA,
            component: () => import("@/views/myData/index.vue"),
            meta: {
              title: t("routes.myData"),
            },

            children: [
              {
                path: "myDataDetail/:id",
                name: RouterName.EDIT_DATA_DETAIL,
                component: () => import("@/views/myData/EditData.vue"),
                meta: {
                  title: "修改信息",
                },
              },
              {
                path: "myAPIDataDetail/:id",
                name: RouterName.EDIT_API_DATA_DETAIL,
                component: () => import("@/views/myData/EditAPIData.vue"),
                meta: {
                  title: "修改信息",
                },
              },
            ],
          },
        ],
      },
      {
        path: "buyer",
        name: "buyer",
        meta: {
          title: "数据买家",
        },
        children: [
          {
            path: "my-order",
            name: RouterName.MY_ORDER,
            component: () => import("@/views/myOrder/index.vue"),
            meta: {
              title: t("routes.myOrder"),
            },
            children: [
              {
                path: "myOrderDetail/:id",
                name: RouterName.ORDER_DETAIL,
                component: () => import("@/views/myOrder/Details.vue"),
                meta: {
                  title: "订单详情",
                },
              },
              {
                path: "myApiOrderDetail/:id",
                name: RouterName.API_ORDER_DETAIL,
                component: () => import("@/views/myOrder/ApiDetails.vue"),
                meta: {
                  title: "订单详情",
                },
              },
            ],
          },
          {
            path: "myApi",
            name: RouterName.MY_API,
            component: () => import("@/views/myApi/index.vue"),
            meta: {
              title: t("routes.myApi"),
            },
          },
          {
            path: "my-report",
            name: RouterName.MY_REPORT,
            component: () => import("@/views/myReport/index.vue"),
            meta: {
              title: t("routes.myReport"),
            },
          },
        ],
      },
    ],
  },
  {
    path: "/publish-data",
    name: RouterName.PUBLISH_DATA,
    component: () => import("@/views/publishData/index.vue"),
    meta: {
      title: t("routes.publishData"),
      keepAlive: true,
    },
  },
  {
    path: "/callback",
    name: RouterName.CALLBACK,
    component: () => import("@/views/login/callback.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/chatwoot-window",
    name: RouterName.CHATWOOT_WINDOW,
    component: () => import("@/views/chatwoot/Window.vue"),
    meta: {
      title: "在线客服",
      hideFloatingService: true,
    },
  },
];

export default clientRoutes;
